import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredOrderOpenAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderOpen',
  (params: { id: string }) => ({
    tradeBrokeredOrderOpen: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
